/*
 * @Descripttion:
 * @Author: Xinner
 * @Date: 2021-01-26 09:28:03
 * @LastEditors: Xinner
 * @LastEditTime: 2021-02-23 11:44:37
 */
import KvSelect from './KvSelect.vue';
import UserName from './UserName';
import StorageUpload from './StorageUpload';
// import StorageObjectDisplay from './StorageDisplay.vue';
import UploadExcel from './UploadExcel.vue';
import HtmlEditor from './HtmlEditor.vue';
import BooleanDisplay from './BooleanDisplay.vue';
import _Vue, { PluginObject } from 'vue';
import Text from './Typography/Text';
// import DeptPath from './DeptPath.vue';
import InputNumberCom from './InputNumberCom.vue';
import NationSelect from './NationSelect.vue';
import Space from './Space.vue';

// import SchoolSelectId from './SchoolSelectId.vue';
// import ExportFile from './ExportFile.vue';
// export type PluginFunction<T> = (Vue: typeof _Vue, options?: T) => void;
export function Ch2ComponsePlugin<AxiosPlugOptions>(Vue: typeof _Vue, options?: Ch2ComponsePluginOptions): void {
  Vue.component('c-username', UserName);
  Vue.component('c-upload', StorageUpload);
  Vue.component('c-text', Text);
  Vue.component('c-html-editor', HtmlEditor);
  Vue.component('c-upload-excel', UploadExcel);
  Vue.component('c-boolean-display', BooleanDisplay);
  Vue.component('c-input-number', InputNumberCom);
  Vue.component('c-nation', NationSelect);
  Vue.component('c-space', Space);
}

export class Ch2ComponsePluginOptions {
  // add stuff
}
